<template>
  <div class="cus-search-wrap">
    <Input
      v-model="value"
      :placeholder="cusPlaceholder ? cusPlaceholder : '请选择'"
      @on-focus="inputFocus($event)"
      @on-keyup="inputKeyup($event)"
      class="cusSearch-input"
      @on-blur="validateEmpty($event)"
      @on-change="inputChange($event)"
      :disabled="ifDisable"
      :size="size == 'small' ? 'small' : 'default'"
    />
    <div
      class="ivu-select-dropdown cus-dropdown"
      :class="{
        'cus-dropdown-normal': transfer != 'true',
        'cus-dropdown-fixed': transfer === 'true'
      }"
      x-placement="bottom-start"
      v-show="showDrop"
      @scroll="scroll($event)"
    >
      <ul class="ivu-select-not-found" v-show="showEmpty">
        <li>无匹配数据</li>
      </ul>
      <ul
        class="ivu-select-dropdown-list dropDownList-wrap"
        v-show="showResult"
      >
        <template v-for="(item, index) in dropDownList">
          <template v-if="item.forbidden">
            <li class="ivu-select-item fgrey" :value="item.id">
              {{ item[resultKey]
              }}<span class="fgrey">{{ showNote ? item.cusNote : "" }}</span>
            </li>
          </template>
          <template v-else>
            <li
              class="ivu-select-item"
              :value="item.id"
              :class="
                isAddSelectItemClass
                  ? index == 0
                    ? 'active ' + addSelectClass
                    : addSelectClass
                  : index == 0
                  ? 'active '
                  : ''
              "
              @click.stop="chooseItem(item.id, item[resultKey], item)"
            >
              {{ item[resultKey] }}
              <span class="fgrey">{{ showNote ? item.cusNote : "" }}</span>
            </li>
          </template>
        </template>
      </ul>
      <ul class="ivu-select-loading" v-show="showLoading">
        加载中
      </ul>
    </div>
  </div>
</template>

<style>
.cus-dropdown-normal {
  position: absolute;
  will-change: top, left;
  transform-origin: center top 0px;
  padding: 0;
  top: 24px;
  left: 0px;
  right: 0px;
}
.cus-dropdown-fixed {
  position: fixed;
  padding: 0;
  max-width: 600px;
}
</style>

<script>
export default {
  props: [
    "searchConfig",
    "cusPlaceholder",
    "ifDisable",
    "enterForbidChoose",
    "showNote",
    "transfer",
    "size",
    "isAddSelectItemClass",
    "addSelectClass"
  ],
  data() {
    return {
      value: "",
      showDrop: false,
      showResult: false,
      showLoading: false,
      showEmpty: false,
      inputPage: 1,
      inputLimit: 10,
      dropDownList: [],
      selectedId: "",
      loading: false,
      selectProject: {},
      //
      // ifDisable: false,
      requestAll: true,
      singlePage: false,
      resultKey: "name",
      throttle: false

      // cusPlaceholder:"请选择"
    };
  },
  mounted() {},
  methods: {
    validateEmpty(param) {
      if (this.searchConfig == "true") {
        this.$emit("validateEmpty", "");
      }
    },
    inputChange(param) {
      if (this.searchConfig == "true") {
        this.$emit("inputChange", "");
      }
      if (this.throttle) {
        this.requestAll = false;
        this.selectedId = "";
        this.inputPage = 1;
        this.showDrop = true;
        this.showLoading = true;
        this.showResult = false;
        this.showEmpty = false;
        this.serachData();
        //获取Input的宽度
        if (this.transfer == "true") {
          $(param.target)
            .parents(".cus-search-wrap")
            .find(".cus-dropdown")
            .css(
              "top",
              Number(
                $(param.target)
                  .parents(".cus-search-wrap")
                  .offset().top
              ) +
                Number(30) +
                "px"
            );
          $(param.target)
            .parents(".cus-search-wrap")
            .find(".cus-dropdown")
            .css(
              "left",
              $(param.target)
                .parents(".cus-search-wrap")
                .offset().left + "px"
            );
          $(param.target)
            .parents(".cus-search-wrap")
            .find(".cus-dropdown")
            .css(
              "minWidth",
              $(param.target)
                .parents(".cus-search-wrap")
                .css("width")
            );
        }
        $(param.target)
          .parents(".cus-search-wrap")
          .find(".cus-dropdown")
          .removeClass("playnone");
      }
    },
    inputFocus(param) {
      this.$emit("inputFocus", "");
      $(".cus-dropdown").addClass("playnone");
      this.throttle = true;
      this.showDrop = true;
      this.inputPage = 1;
      this.dropDownList = [];
      this.serachData();
      //获取Input的宽度
      if (this.transfer == "true") {
        $(param.target)
          .parents(".cus-search-wrap")
          .find(".cus-dropdown")
          .css(
            "top",
            Number(
              $(param.target)
                .parents(".cus-search-wrap")
                .offset().top
            ) +
              Number(30) +
              "px"
          );
        $(param.target)
          .parents(".cus-search-wrap")
          .find(".cus-dropdown")
          .css(
            "left",
            $(param.target)
              .parents(".cus-search-wrap")
              .offset().left + "px"
          );
        $(param.target)
          .parents(".cus-search-wrap")
          .find(".cus-dropdown")
          .css(
            "minWidth",
            $(param.target)
              .parents(".cus-search-wrap")
              .css("width")
          );
      }
      $(param.target)
        .parents(".cus-search-wrap")
        .find(".cus-dropdown")
        .removeClass("playnone");
      if (this.value == "") {
        this.selectedId = "";
      }
      if (param.keyCode == "13") {
        return false;
      }

      //下拉框外点击需要隐藏
      function hideSearchInput(e) {
        if ($(e.target).parents(".cus-search-wrap ").length == 0) {
          $(".cus-dropdown").addClass("playnone");
          document.body.removeEventListener("click", hideSearchInput);
        }
      }
      document.body.addEventListener("click", hideSearchInput);
    },
    inputKeyup(param) {
      let enterForbidChoose = this.enterForbidChoose == "true" ? true : false;
      if (
        param.keyCode == "13" &&
        this.dropDownList.length != 0 &&
        enterForbidChoose == false
      ) {
        //回车选中第一条
        this.chooseItem(
          this.dropDownList[0].id,
          this.dropDownList[0][this.resultKey],
          this.dropDownList[0]
        );
        $(".cusSearch-input")
          .find(".ivu-input")
          .blur();
        $(".cus-dropdown").addClass("playnone");
        return false;
      } else {
        if (param.keyCode == "13" && enterForbidChoose == true) {
          this.clearStatus();
          this.enterMethod();
          return "";
        }
      }
    },
    chooseItem(param, param1, param2) {
      this.selectedId = param;
      this.selectProject = param2;
      this.value = param1;
      this.showDrop = false;
      this.showResult = false;
      this.showLoading = false;
      this.showEmpty = false;
      this.requestAll = true;
      this.throttle = false;
      this.selectItem();

      if (this.searchConfig == "true") {
        this.$emit("validateEmpty", "");
      }
    },
    selectItem() {
      this.$emit("selectItem", "");
    },
    enterMethod() {
      this.$emit("enterMethod", "");
    },
    //查询数据
    serachData() {
      this.loading = true;
      if (this.inputPage == 1) {
        this.showResult = false;
        this.showLoading = true;
        this.dropDownList = [];
      }
      this.$emit("serachData", "");
    },
    dealwithData(res) {
      this.showDrop = true;
      let data = res;
      if (this.inputPage == 1) {
        this.dropDownList = data.list;
      } else {
        this.dropDownList = this.dropDownList.concat(data.list);
      }

      //数据为空
      if (data.list.length == 0) {
        this.loading = true;
        this.showLoading = false;
        if (this.inputPage == 1) {
          this.showResult = false;

          this.showEmpty = true;
        }
      } else {
        this.showLoading = false;
        this.showEmpty = false;
        this.showResult = true;
        this.loading = false;
        if (this.transfer == "true") {
          let dValue = Number(
            $(window).height() -
              $(".cus-dropdown-fixed")
                .not(".playnone")
                .offset().top
          );
          if (dValue < 290) {
            let bottom =
              dValue +
              Number(
                $(".cus-dropdown-fixed")
                  .not(".playnone")
                  .prev()
                  .height()
              );
            $(".cus-dropdown-fixed")
              .not(".playnone")
              .css("bottom", bottom + "px");
            $(".cus-dropdown-fixed")
              .not(".playnone")
              .css("top", "auto");
          }
        }
      }
    },
    scroll(param) {
      if (!this.loading && !this.singlePage) {
        var dropDownHeight = $(param.target)
          .parents(".cus-search-wrap")
          .find(".cus-dropdown")
          .height();
        var listHeight = $(param.target)
          .parents(".cus-search-wrap")
          .find(".dropDownList-wrap")
          .height();
        if (
          Number(dropDownHeight) +
            Number(param.target.scrollTop) +
            Number(10) >=
          listHeight
        ) {
          this.inputPage = Number(this.inputPage) + 1;
          this.serachData();
        }
      }
    },
    clearStatus() {
      this.inputPage = 1;
      this.showDrop = false;
      this.dropDownList = [];
      this.showEmpty = false;
      this.showResult = false;
      this.showLoading = false;
    },
    setFalse() {}
  }
};
</script>
<style scoped>
.playnone {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/searchInputTransfer.vue